import React from 'react';
import { Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';

interface PageHeaderProps {
  text: string;
  variant?: Variant;
}

const PageHeader: React.FC<PageHeaderProps> = ({ text, variant = 'h5' }) => {
  return <Typography variant={variant}>{text}</Typography>;
};

export default PageHeader;
